import Users from "./Users";

const ResellerBundleUsers = () => {
  return (
    <div>
      <Users
        userCat={"Bundle"}
        addUserCTA="Create Bundle User Account"
        userPageTitle="Bundle Users"
      />
    </div>
  );
};

export default ResellerBundleUsers;
